const CHECKOUT_DEFAULT_INCLUDES = [
    'cart.lineItems.physicalItems.options',
    'cart.lineItems.physicalItems.stockPosition',
    'cart.lineItems.digitalItems.options',
    'cart.lineItems.digitalItems.stockPosition',
    'customer',
    'customer.customerGroup',
    'payments',
    'promotions.banners',
];

export default CHECKOUT_DEFAULT_INCLUDES;
